/**
 *
 * @returns {{googleMapsApiKey: string}|null}
 */
const getAppConfig = () =>
{
	const configElem = document.querySelector( '#app-config' );

	if (configElem instanceof HTMLElement) {
		return JSON.parse( configElem.innerText );
	}

	return null;
};


/**
 *
 * @returns {Community|null}
 */
const getCurrentCommunity = () =>
{
	const currentCommunityElem = document.querySelector( '#esl-current-community' );

	if (currentCommunityElem instanceof HTMLElement) {
		return JSON.parse( currentCommunityElem.innerText );
	}

	return null;
};

/**
 *
 * @typedef {{template: string, delay: number, endDate: null, name: string, html: string, url: string, startDate: null}} SiteNotice
 */

/**
 *
 * @returns {SiteNotice[]|null}
 */
const getSiteNotices = () =>
{
	const siteNoticesElem = document.querySelector( '#esl-site-notices' );

	if (siteNoticesElem instanceof HTMLElement) {
		return JSON.parse( siteNoticesElem.innerText );
	}

	return null;
};


/**
 *
 */
export {getAppConfig, getCurrentCommunity, getSiteNotices};